export const routes = {
  home: "/",
  shop: "/shop",
  search: "/search",
  cart: "/bag",
  about: "/about",
  delivery: "/delivery-returns",
  faq: "/faq",
  terms: "/terms",
  productHtml: "/product.html",
  contact: "/pages/contact.html",
  termsLegacy: "/pages/terms.html",
  notFound: "/404.html"
} as const;

export const publishedPolicyLinks = [
  { label: "Terms of use", to: routes.terms },
  { label: "Delivery & Returns", to: routes.delivery }
] as const;

export function shopCategoryPath(categoryId: string) {
  return `${routes.shop}/${encodeURIComponent(categoryId)}`;
}

export function productPath(slug: string) {
  return `/products/${encodeURIComponent(slug)}`;
}

export function bundlePath(slug: string) {
  return `/bundles/${encodeURIComponent(slug)}`;
}

export const htmlRedirects = [
  { from: "shop.html", to: routes.shop },
  { from: "pages/about.html", to: routes.about },
  { from: "pages/delivery-returns.html", to: routes.delivery },
  { from: "pages/faq.html", to: routes.faq },
  { from: "pages/terms.html", to: routes.terms }
] as const;
